import axiosInstance from './api'

const STUB_LINES = [
	"Let's start with the Country Finder follow-up from last session.",
	'Student is leaning toward UCLA for Computer Science because of ranking and flexibility.',
	'Parents are still concerned about overall cost and scholarship clarity.',
	'UCSD aid looks stronger by roughly eight thousand dollars each year.',
	'Need a cleaner comparison before the next conversation.',
	'Student also wants a simpler shortlist for scholarships and essay deadlines.',
]

const STUB_FAIL_CHUNK = Number(process.env.REACT_APP_STT_STUB_FAIL_CHUNKS || 0)

function shouldUseRealApi() {
	const flag = String(process.env.REACT_APP_NOTE_TAKER_SPEECH_API || '')
		.trim()
		.toLowerCase()
	if (flag === 'false' || flag === 'stub') return false
	// Jest runs without env files — keep the stub unless a test opts into real API.
	if (process.env.NODE_ENV === 'test' && flag !== 'true') return false
	// Default: real STT (opt-out via REACT_APP_NOTE_TAKER_SPEECH_API=false|stub).
	return true
}

async function transcribeChunkReal({
	recordingId,
	chunkId,
	blob,
	mimeType,
	startMs,
	endMs,
	language,
	signal,
}) {
	const formData = new FormData()
	formData.append('file', blob, `recording-${recordingId || 'live'}.webm`)
	formData.append('recordingId', String(recordingId || ''))
	formData.append('chunkId', String(chunkId))
	formData.append('startMs', String(startMs ?? ''))
	formData.append('endMs', String(endMs ?? ''))
	formData.append('mimeType', mimeType || blob?.type || '')
	if (language) formData.append('language', language)

	const { data } = await axiosInstance.post('/counseling/stt/transcribe', formData, {
		headers: { 'Content-Type': undefined },
		signal,
		timeout: 120000,
	})

	return {
		text: String(data?.text || ''),
		startMs: data?.startMs ?? startMs,
		endMs: data?.endMs ?? endMs,
		speaker: data?.speaker ?? null,
	}
}

function delay(ms, signal) {
	return new Promise((resolve, reject) => {
		if (signal?.aborted) {
			reject(signal.reason || new DOMException('Aborted', 'AbortError'))
			return
		}

		const timeoutId = window.setTimeout(resolve, ms)
		const onAbort = () => {
			window.clearTimeout(timeoutId)
			reject(signal?.reason || new DOMException('Aborted', 'AbortError'))
		}

		signal?.addEventListener('abort', onAbort, { once: true })
	})
}

/**
 * Frontend stub for per-chunk STT. Swap implementation when backend lands.
 */
export async function transcribeChunk({
	recordingId,
	chunkId,
	blob,
	mimeType,
	startMs,
	endMs,
	language,
	signal,
}) {
	if (shouldUseRealApi()) {
		return transcribeChunkReal({
			recordingId,
			chunkId,
			blob,
			mimeType,
			startMs,
			endMs,
			language,
			signal,
		})
	}

	void recordingId
	void blob
	void mimeType

	const latencyMs = 300 + Math.floor(Math.random() * 500)
	await delay(latencyMs, signal)

	if (STUB_FAIL_CHUNK > 0 && Number(chunkId) === STUB_FAIL_CHUNK) {
		const error = new Error(`Stub transcription failed for chunk ${chunkId}`)
		error.name = 'TranscriptionError'
		throw error
	}

	const line = STUB_LINES[(Number(chunkId) - 1) % STUB_LINES.length]
	const text = line || `Transcribed chunk ${chunkId}.`

	return {
		text,
		startMs,
		endMs,
		speaker: null,
	}
}
